export const domainKey = 'palace-bet'
// export const domainName = `www.${domainKey}.games`
// export const domainName = `www.${domainKey}.com`
export const domainName = `www.${domainKey}.mx`
// export const domainName = 'dev.leo-pp.com'
// export const domainName = 'dev.morena888.com'
// export const domainName = 'dev-brazilv5.tt-22.com'
// export const domainName = 'dev-mexico7.7777ru.com'
// export const domainName = 'dev-russ.moose888.com'
// export const host = window.location.origin + '/api'
export const host = `https://${domainName}/api`
// export const host = window.location.origin + '/api' // 上线正式
// export const host = 'http://dev.rei-bet.com/api'
// export const host = "http://8.218.60.59:9202"
export const inviteCodeKey = 'inviteMemberId'
export const domain = `https://${domainName}`
export const webSocketUrl = `wss://${domainName}/api/onlineSend`
export const pn = 'm053'

// 是否显示主题切换功能
export const showThemeSkinSelect = false
// 用户未选择主题时使用的默认主题
export const defaultThemeSkin = process.env.VUE_APP_THEME_SKIN || 'blackGold'
// 是否只打包默认主题
export const buildOnlyDefaultTheme = process.env.VUE_APP_THEME_MODE === 'single'
